import httpClientService from '../httpClientService';
export default {
	getInventoryForms: () =>
		httpClientService.Get(
			'/ProjectInventoryFormsModule/api/InventoryForms'
		),
	getById: (id) =>
		httpClientService.Get(
			`/ProjectInventoryFormsModule/api/InventoryForms/${id}`
		),
	saveRecord: (record, process) =>
		httpClientService.PostMultiPart(
			`/ProjectInventoryFormsModule/api/InventoryForms?process=${process}`,
			record
		),
	bulkEdit: (record) =>
		httpClientService.Post(
			`/ProjectInventoryFormsModule/api/BulkEdit`,
			record
		),
	checkUniqueValues: (payload) =>
		httpClientService.Post(
			`/ProjectInventoryFormsModule/api/InventoryForms/ValidateUniqueValues`,
			payload
		),

	getAllForms: () =>
		httpClientService.Get('/ProjectInventoryFormsModule/api/FormBuilder'),
	getFormById: (id) =>
		httpClientService.Get(
			'/ProjectInventoryFormsModule/api/FormBuilder/' + id
		),
	insertForm: (item) =>
		httpClientService.Post(
			'/ProjectInventoryFormsModule/api/FormBuilder',
			item
		),
	updateForm: (item) =>
		httpClientService.Put(
			`/ProjectInventoryFormsModule/api/FormBuilder/${item.Id}`,
			item
		),
	deleteForm: (id) =>
		httpClientService.Delete(
			'/ProjectInventoryFormsModule/api/FormBuilder/' + id
		),
	cloneForm: (item) =>
		httpClientService.Post(
			'/ProjectInventoryFormsModule/api/FormBuilder/CloneInventoryForm',
			item
		),

	getFormFields: (inventoryFormId) =>
		httpClientService.Get(
			`/ProjectInventoryFormsModule/api/FormFields?inventoryFormId=${inventoryFormId}`
		),
	getFormFieldsByEntityId: (entityId) =>
		httpClientService.Get(
			'/ProjectInventoryFormsModule/api/GridViewFields/' + entityId
		),
	insertFormField: (formField) =>
		httpClientService.Post(
			'/ProjectInventoryFormsModule/api/FormFields',
			formField
		),
	updateFormField: (formField) =>
		httpClientService.Put(
			`/ProjectInventoryFormsModule/api/FormFields/${formField.Id}`,
			formField
		),
	deleteFormField: (formField) =>
		httpClientService.Delete(
			`/ProjectInventoryFormsModule/api/FormFields/${formField.Id}`
		),
	reorderFormField: (param1, param2) => {
		let data = { InventoryFormId: param1, Fields: param2 };
		return httpClientService.Post(
			'/ProjectInventoryFormsModule/api/FormFields/ReorderFields',
			data
		);
	},
	updateMobileHeaders: (param1, param2) => {
		let data = { InventoryId: param1, FormFieldIds: param2 };
		return httpClientService.Post(
			'/ProjectInventoryFormsModule/api/FormFields/UpdateMobileHeaders',
			data
		);
	},

	getGridViewFields: (inventoryFormId) =>
		httpClientService.Get(
			`/ProjectInventoryFormsModule/api/GridViewFields?inventoryFormId=${inventoryFormId}`
		),

	getInteractionByInventotyFormId: (id) =>
		httpClientService.Get(
			'/ProjectInventoryFormsModule/api/InventoryFormInteraction?id=' + id
		),
	getInteractionById: (id) =>
		httpClientService.Get(
			'/ProjectInventoryFormsModule/api/InventoryFormInteraction/' + id
		),
	insertInteraction: (item) =>
		httpClientService.Post(
			'/ProjectInventoryFormsModule/api/InventoryFormInteraction',
			item
		),
	updateInteraction: (item) =>
		httpClientService.Put(
			`/ProjectInventoryFormsModule/api/InventoryFormInteraction/${item.Interaction.Id}`,
			item
		),
	deleteInteraction: (id) =>
		httpClientService.Delete(
			'/ProjectInventoryFormsModule/api/InventoryFormInteraction/' + id
		),

	getProjectUsers: (id) =>
		httpClientService.Get(
			'/ProjectInventoryFormsModule/api/UserAssign/GetProjectUsers?id=' +
				id
		),

	getInventoryFormUsers: (id) =>
		httpClientService.Get(
			'/ProjectInventoryFormsModule/api/UserAssign/GetInventoryFormUsers?id=' +
				id
		),
	insertInventoryFormUser: (inventoryId, users) => {
		let data = { InventoryId: inventoryId, Users: users };
		return httpClientService.Post(
			'/ProjectInventoryFormsModule/api/UserAssign/AddInventoryFormUser',
			data
		);
	},
	deleteInventoryFormUser: (inventoryId, users) => {
		let data = { InventoryId: inventoryId, Users: users };
		return httpClientService.Delete(
			'/ProjectInventoryFormsModule/api/UserAssign/RemoveInventoryFormUser',
			data
		);
	},

	getEntities: () =>
		httpClientService.Get('/ProjectInventoryFormsModule/api/Entities'),
	getReferenceListTypes: () =>
		httpClientService.Get(
			'/ProjectInventoryFormsModule/api/ReferenceListTypes'
		),
	getReferenceListValues: () =>
		httpClientService.Get(
			'/ProjectInventoryFormsModule/api/ReferenceListValues'
		),
	getReferenceListValuesByTypeId: (referenceListTypeId) =>
		httpClientService.Get(
			`/ProjectInventoryFormsModule/api/ReferenceListValues?typeId=${referenceListTypeId}`
		),

	getFilters: (inventoryFormId) =>
		httpClientService.Get(
			'/ProjectInventoryFormsModule/api/InventoryFormFilter?inventoryFormId=' +
				inventoryFormId
		),
	insertFilters: (item) =>
		httpClientService.Post(
			'/ProjectInventoryFormsModule/api/InventoryFormFilter',
			item
		),
	updateFilters: (item) =>
		httpClientService.Put(
			'/ProjectInventoryFormsModule/api/InventoryFormFilter/',
			item
		),
	deleteFilters: (inventoryFormId, gridViewId) =>
		httpClientService.Delete(
			`/ProjectInventoryFormsModule/api/InventoryFormFilter?inventoryFormId=${inventoryFormId}&gridViewId=${gridViewId}`
		),

	loadGridViewData: (item) =>
		httpClientService.Post(
			'/ProjectInventoryFormsModule/api/GridViews/LoadData',
			item
		),
	loadGridViewDataById(gridViewId, itemId) {
		return httpClientService.Get(
			`/ProjectInventoryFormsModule/api/GridViews/LoadDataById?gridViewId=${gridViewId}&itemId=${itemId}`
		);
	},

	updateColumns: (param1, param2) => {
		let data = { GridViewId: param1, Columns: param2 };
		return httpClientService.Post(
			'/ProjectInventoryFormsModule/api/GridViews/SetVisibleColumns',
			data
		);
	},

	getDefaultGridViews: () =>
		httpClientService.Get(
			'/ProjectInventoryFormsModule/api/GridViews/GetDefaultGridViews'
		),
	insertGridView: (params) =>
		httpClientService.Post(
			'/ProjectInventoryFormsModule/api/GridViews/',
			params
		),
	deleteGridView: (gridId, inventoryFormId) =>
		httpClientService.Delete(
			`/ProjectInventoryFormsModule/api/GridViews/${gridId}?inventoryFormId=${inventoryFormId}`
		),
	setDefaultView: (gridId, inventoryFormId, isDefault) =>
		httpClientService.Post(
			`/ProjectInventoryFormsModule/api/GridViews/SetAsDefaultView/${gridId}?inventoryFormId=${inventoryFormId}&isDefault=${isDefault}`
		),
	setGlobalView: (gridId, isGlobal) =>
		httpClientService.Post(
			`/ProjectInventoryFormsModule/api/GridViews/SetGlobalView/${gridId}?isGlobal=${isGlobal}`
		),
	exportGridData: (payload) =>
		httpClientService.PostForExport(
			'/ProjectInventoryFormsModule/api/Export/ExportExcel',
			payload
		),
	loadHistoryData: (payload) =>
		httpClientService.Post(
			'/ProjectInventoryFormsModule/api/GridViewHistory/LoadData',
			payload
		),
};
